import { render, staticRenderFns } from "./LinkedCustomInvestorGoalCard.vue?vue&type=template&id=fe585532&scoped=true&"
import script from "./LinkedCustomInvestorGoalCard.vue?vue&type=script&lang=ts&"
export * from "./LinkedCustomInvestorGoalCard.vue?vue&type=script&lang=ts&"
import style0 from "./LinkedCustomInvestorGoalCard.vue?vue&type=style&index=0&id=fe585532&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe585532",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VChip,VCol,VDivider,VImg,VProgressLinear,VRow})
